import React, { lazy, Suspense } from 'react';

const LazyOrdersPagePage = lazy(() => import('./OrdersPage'));

const OrdersPage = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyOrdersPagePage {...props} />
  </Suspense>
);

export default OrdersPage;
